import { currencyApi } from "api/Currency/api.ts";
import { useQueryApi } from "api/hooks.ts";

import GetCurrenciesResponse = App.Http.Responses.Currency.GetCurrenciesResponse;

export const useCreateTenantCurrencySelectOptions = () => {
    const { data, isLoading, error } = useQueryApi<GetCurrenciesResponse>({
        queryKey: ["createTenantCurrencies"],
        queryFn: () => currencyApi.index(),
    });

    const options = [...(data?.currencies ?? [])]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((currency) => ({
            label: `${currency.name} (${currency.currency_code})`,
            value: currency.currency_code,
        }));

    return {
        options,
        loading: isLoading,
        error: error?.message ?? null,
    };
};
